import React, { Component } from 'react';
import withFirebase from 'view/FirebaseAnalytics/withFirebase';
import { Card, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { withLocale } from '@dietlabs/components';
import Markdown from 'markdown-to-jsx';
import SaleProduct from './SaleProduct';
import { callNativeApp } from '../components/Helpers/callNativeApp';

class SaleProducts extends Component {
    static propTypes = {
        saleProduct: PropTypes.instanceOf(SaleProduct).isRequired,
        showShortDescription: PropTypes.bool.isRequired,
        showThumbnail: PropTypes.bool,
        t: PropTypes.func.isRequired,
        trackFirebaseEvent: PropTypes.func.isRequired,
        articleId: PropTypes.number.isRequired,
    };

    static defaultProps = {
        showThumbnail: false,
    };

    handleOnClick = () => {
        callNativeApp('/', 'buy-diet');
        this.props.trackFirebaseEvent('user_action', {
            action: 'tap-buy_access',
            location: 'Feed_ID',
            feed_ID: this.props.articleId,
        });
    };

    render() {
        const replaceUl = ({ children }) => (
            <ul className="product-ul">{children}</ul>
        );
        const replaceLi = ({ children }) => (
            <li className="product-li">{children}</li>
        );

        const markdownOptions = {
            overrides: {
                ul: {
                    component: replaceUl,
                },
                li: {
                    component: replaceLi,
                },
            },
        };
        const { saleProduct } = this.props;

        return (
            <Card className="product">
                {saleProduct.isBestseller ? (
                    <div className="product-bestseller">bestseller</div>
                ) : (
                    ''
                )}
                <div className="card-header">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: this.props.showShortDescription
                                ? saleProduct.shortDescription
                                : saleProduct.name,
                        }}
                        className="product-name"
                    />
                </div>
                <div className="card-body pt-0">
                    {this.props.showThumbnail ? (
                        <img
                            src={saleProduct.thumbnailUrl}
                            className="img-fluid mb-3"
                            alt={saleProduct.name}
                        />
                    ) : (
                        ''
                    )}

                    <Markdown options={markdownOptions}>
                        {saleProduct.features}
                    </Markdown>
                    <span
                        data-test="product-description"
                        className="product-description"
                    >
                        {saleProduct.lengthLabel}
                    </span>
                </div>
                <div className="card-footer pt-0 pb-4">
                    <Button color="primary" onClick={this.handleOnClick}>
                        {this.props.t('button/buy-now')}
                    </Button>
                </div>
            </Card>
        );
    }
}

export default withFirebase(withLocale(SaleProducts));
